module.exports = __webpack_public_path__ + "img/yzcxyh.acf447be.png";